<template>
  <component v-bind="containerTag.props" :is="containerTag.name">
    <!-- <slot name = "before-name" /> -->
    <!-- <component
      v-bind = "{...parrierTag.props, ...customBind.name || {} }"
      :is = "parrierTag.name">
      <v-text-field
        v-bind = "{ ...customBind.nameInput || {} , ...textFieldProps}"
        v-model = "input.name"
        placeholder = "Entity Name" />
    </component>
    <slot name = "before-type" />
    <component
      v-bind = "{...parrierTag.props, ...customBind.type || {} }"
      :is = "parrierTag.name">
      <v-btn 
        flat 
        color = "primary" 
        @click = "typeDialog = true">
        {{ input.type || 'Select Type' }} -->
    <v-dialog v-model="typeDialog" width="500">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ put ? "Edit" : "Add" }} Entity
        </v-card-title>
        <v-card-text>
          <div>
            <label>Name</label>
            <v-text-field
              v-model="input.name"
              placeholder="Entity Name"
              outline
            />
            <label>Type</label>
            <v-select
              v-model="input.type"
              :items="[
                { text: 'List', value: 'list' },
                { text: 'Regex', value: 'regex' },
                { text: 'Machine Learning', value: 'machine_learning' },
              ]"
              placeholder="Entity Type"
              item-value="value"
              item-text="text"
              outline
            />
            <label v-if="input.type === 'regex'">Regex</label>
            <v-text-field
              v-if="input.type === 'regex'"
              v-model="input.regex"
              :items="[
                { text: 'List', value: 'list' },
                { text: 'Regex', value: 'regex' },
                { text: 'Machine Learning', value: 'machine_learning' },
                { text: 'Pattern', value: 'pattern' },
              ]"
              placeholder="Entity Type"
              item-value="value"
              item-text="text"
              outline
            />
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="typeDialog = false"> Cancel </v-btn>
          <v-btn color="primary" @click="submit"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  </v-btn>
    </component>
    <slot
      v-for = "(slot, s) in new Array(slots)"
      :name = "`tail-slot-${ s + 1 }`" /> -->
  </component>
</template>

<script>
export default {
  name: "AddEntity",
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true,
        };
      },
    },
    slots: {
      type: Number,
      default: 2,
    },
    customBind: {
      type: Object,
      default() {
        return {};
      },
    },
    put: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isValid: false,
      input: {
        name: "",
        type: null,
        regex: "",
        entity_category: 1,
      },
      typeItems: [],
      typeDialog: false,
      isLoading: false,
    };
  },
  watch: {
    put(val) {
      if (val) this.input = val;
      else this.resetForm();
    },
  },
  mounted() {
    const vm = this;
    setTimeout(() => {
      const selector = document.querySelector(`#add-entities-${this._uid}`);
      if (selector)
        selector.addEventListener("keydown", (e) => {
          window.s = selector;
          if (e.keyCode === 13) {
            vm.typeItems.push(e.target.value);
            vm.input.type.push(e.target.value);
            setTimeout(() => {
              selector.value = "";
            }, 100);
          }
        });
    }, 1000);
  },
  methods: {
    handler(e) {
      console.log(e);
    },
    setType() {
      // some code
    },
    async submit() {
      if (this.input.name.length && this.input.type && this.input.type.length) {
        this.isLoading = true;
        this.emitLoading(true);
        const payload = this.put
          ? { ...this.input, id: this.put.id }
          : this.input;
        const response = await this.$store.dispatch(
          `nlp/entities/${this.put ? "update" : "add"}`,
          payload
        );

        this.resetForm();
        this.emitLoading(false);
        this.isLoading = false;
        this.$emit("success", response.data);
        this.typeDialog = false;
      } else
        this.$store.dispatch("setSnackbar", {
          text: "Some fields are missing.",
        });
    },
    async resetForm() {
      this.input = {
        name: "",
        type: null,
        regex: "",
        entity_category: 1,
      };
      return true;
    },
    emitLoading(status = true) {
      this.$emit("loading", status);
    },
    openDialog() {
      this.typeDialog = true;
    },
  },
};
</script>

<style lang="css" scoped></style>
